<template>
  <div>
    <alert-custom v-if="showAlert" :messageAlert="messageAlert">
      <template v-slot>
        <p class="error-message">
          El inicio de sesión automático ha fallado.<br><br>
          Redirigiendo a la página de login.
        </p>
      </template>
    </alert-custom>
  </div>

</template>
<script>
import AlertCustom from './AlertCustom.vue'
import LoginService from './login.service'
import { getUserData, isUserLoggedIn, getHomeRouteForLoggedInUser } from '@/auth/utils'
export default {
  name: 'auth-token',
  components: {AlertCustom},
  data () {
    return {
      loginService: new LoginService(this),
      showAlert: false,
      messageAlert: {}
    }
  },
  mounted () {
    this.setInitialData()
  },
  methods: {
    setInitialData () {
      if (!!this.$route.query?.token) {
        document.getElementById('loading-bg').style.display = 'block'
        this.userToken = this.$route.query?.token || null
        this.getCustomToken()
      } else {
        this.redirectLogin()
      }
    },
    getCustomToken () {
      this.loginService.callService('exchangeToken', { token: this.userToken })
        .then(resp => {
          this.sucessTokenCreated(resp.data)
        })
        .catch((e) => {
          this.errorAuthentication()
        })

    },
    sucessTokenCreated (data) {
      this.customLogin(data.token)
    },
    errorAuthentication() {
      document.getElementById('loading-bg').style.display = 'none'
      if (!isUserLoggedIn()) {
        this.redirectLogin()
      } else {
        this.redirectHome()
      }
    },
    redirectLogin() {
      this.showAlert = true
      this.messageAlert = {
        type: 'error',
        title: 'Inicio de Sesión Automático'
      }
      setTimeout(() => {
        this.$router.push({ name: 'auth-login' })
      }, 5000)
    },
    redirectHome () {
      const user = getUserData()
      const homeRoute = getHomeRouteForLoggedInUser(user.role)
      if (homeRoute) {
        this.$router.replace(homeRoute)
      }
    },
    customLogin (token) {
      if (!this.m_isFirebaseJwtFormatValid(token)) {
        this.errorAuthentication()
      } else {
        this.$root.$data.auth
          .signInWithCustomToken(token)
          .then((data) => {
            this.$root.$data.auth.setPersistence(this.$root.$data.fb.auth.Auth.Persistence.LOCAL)
            this.loggedUser = data.user
            return data.user.getIdToken()
          })
          .then((token) => {
            this.$store.dispatch('fetchUserData', {id: this.loggedUser.uid, token, from: 'custom-token', remember: true })
          })
          .catch(() => {
            this.errorAuthentication()
          })
      }
    }
  }
}
</script>

<style>

</style>